import React, { createContext, useContext, useEffect } from 'react'
import { useSocketManager } from './SocketManager'
import { eventAlert, getAccessToken } from './helpers'

const WebSocketContext = createContext()

export const WebSocketProvider = ({ children }) => {
  const socketManager = useSocketManager()
  const accessToken = getAccessToken()

  useEffect(() => {
    if (accessToken && window.navigator.onLine) {
      socketManager.connect()
    } else {
      eventAlert(
        'Please check your connection and refresh the page in sometime',
        'Error',
        'Network connection failed!'
      )
    }

    return () => {
      socketManager.close()
    }
    // connect/close are stable via refs inside useSocketManager; only reconnect when token changes
  }, [accessToken])

  return (
    <WebSocketContext.Provider value={socketManager}>
      {children}
    </WebSocketContext.Provider>
  )
}

export const useWebSocket = () => {
  return useContext(WebSocketContext)
}
